import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BorderPicker } from '../ColorPicker'
import { updateEntityAction, destroyDoorControllerAction, deleteDoorAction } from 'actions/entityActions'
import { zoomToDoorControllerAction } from 'actions/mapActions'
import { notificationAction } from 'actions/notificationActions'

const mapStateToProps = (state, ownProps) => {
  const { entities: { doorControllers, doors }, currentEntity: { id }, map: { ref } } = state

  return {
    currentDoorEntity: ownProps.isController ? doorControllers.byId[id] : doors.byId[id],
    map: ref
  }
}

const initialState = { showBorderPicker: false }

class DoorEntityDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = { ...initialState }
  }

  setHexValue = (value, _, close = true) => {
    const { updateEntityAction, currentDoorEntity: { id }, isController } = this.props
    updateEntityAction(isController ? 'doorControllers' : 'doors', id, { color: value })

    if (close) this.setState(initialState)
  }

  toggle = key => {
    if (this.state[key]) this.setState(initialState)
    else this.setState({ ...initialState, [key]: true })
  }

  renderBody() {
    const { setHexValue, state: { showBorderPicker }, props: { currentDoorEntity, isController, updateEntityAction, classes } } = this
    const { id, name, color } = currentDoorEntity

    if (showBorderPicker) return <BorderPicker cameraOnly { ...{ strokeColor: color, setHexValue, labelText: 'Color' } } />

    return (
      <div>
        <div className={classes.row}>
          <span>Name</span>
          <input
            type='text'
            className={classes.nameInput}
            onChange={({ target: { value } }) => updateEntityAction(isController ? 'doorControllers' : 'doors', id, { name: value })}
            value={name || ''}
          />
        </div>
        <div className={classes.row} style={{ flexDirection: 'column' }}>
          <span className={classes.helpText}>
            <FontAwesomeIcon icon='info-circle' className={classes.helpIcon} />
            Configuring access control systems is not currently supported in the mobile Designer / Calculator
          </span>
          <a
            href={`${IPVM_URL}/contact?&subject=Feature Request: Access Control on Mobile Designer / Calculator&message=I would like to request the ability to configure access control systems in the mobile version of the Designer / Calculator`}
            target='_blank'
            className={classes.helpButton}
          >
            Request this feature now
          </a>
        </div>
      </div>
    )
  }

  render() {
    const { toggle, props: { currentDoorEntity, map, isController, updateEntityAction, destroyDoorControllerAction,
      deleteDoorAction, zoomToDoorControllerAction, notificationAction, classes } } = this

    if (!currentDoorEntity) return null

    const { id, color, location, locked } = currentDoorEntity
    const type = isController ? 'Door Controller' : 'Door'

    return (
      <div className={classes.doorEntityDetails}>
        <div className={classes.header}>
          Edit {type}
        </div>
        <div className={classes.buttonsContainer}>
          <div
            onClick={_ => {
              if (locked) notificationAction(`Cannot delete locked ${type}`)
              else {
                if (isController) {
                  destroyDoorControllerAction(id)
                } else {
                  deleteDoorAction(id)
                }
              }
            }}
            className={classes.deleteButton}
          >
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </div>
          <div className={classes.colorButton} onClick={_ => toggle('showBorderPicker')} style={{ color: color === '#0000' ? 'white' : color }}>
            <FontAwesomeIcon icon={isController ? ['far', 'microchip'] : ['far', 'door-open']} className={classes.colorIcon} />
          </div>
          <div onClick={_ => isController ? zoomToDoorControllerAction(currentDoorEntity) : map.panTo(location)}>
            <FontAwesomeIcon icon='map-marker-alt' />
          </div>
          <div onClick={_ => updateEntityAction(isController ? 'doorControllers' : 'doors', id, { locked: !locked })}>
            <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} />
          </div>
        </div>
        { this.renderBody() }
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateEntityAction, destroyDoorControllerAction, deleteDoorAction,
  zoomToDoorControllerAction, notificationAction })(injectSheet(style)(DoorEntityDetails))



// WEBPACK FOOTER //
// ./src/components/BottomBar/DoorEntityDetails/index.js